export enum PersonalityRole {
  Mediator = "Mediator",
  Advisor = "Advisor",
  Innovator = "Innovator",
  Controller = "Controller",
  Director = "Director",
  Motivator = "Motivator",
  Brakeman = "Brakeman",
  Critic = "Critic",
  Driver = "Driver",
}

export enum ReflectionType {
  Challenge = "challenge",
  Leverage = "leverage",
}
